import type { Middleware } from '@reduxjs/toolkit';
import { baseApi } from '../api/baseApi';

type WithAuth = { auth: { user: { id: string } | null }; preferences?: { genderFilter?: string | null } };

/**
 * Empties the RTK Query cache whenever the signed-in account changes (sign in, sign out, a new
 * account verified, a session that expired). Nothing cleared it before: after one person signed
 * out and another signed in on the same phone, screens that didn't happen to refetch showed the
 * first person's data. Profile showed "Farhan Ahmed" above Tasnim's points.
 * It also empties it when the shop-gender filter changes, so the shop lists reload for the new filter.
 */
export const resetCacheOnAccountChange: Middleware = (store) => (next) => (action) => {
  const was = store.getState() as WithAuth;
  const before = was.auth.user?.id ?? null;
  const filterBefore = was.preferences?.genderFilter ?? null;
  const result = next(action);
  const now = store.getState() as WithAuth;
  const after = now.auth.user?.id ?? null;
  // A different shop-gender filter means every cached shop list is the wrong list.
  if (before !== after || filterBefore !== (now.preferences?.genderFilter ?? null)) store.dispatch(baseApi.util.resetApiState());
  return result;
};
